export const contentTableConfig = {
  title: '访问记录',
  propList: [
    {
      prop: 'deptName',
      label: '部门名称',
      minWidth: '80',
      slotName: 'dept'
    },
    {
      prop: 'materialTitle',
      label: '素材标题',
      minWidth: '120',
      slotName: 'title'
    },
    { prop: 'pv', label: '访问次数(pv)', minWidth: '80', sortable: true },
    {
      prop: 'uv',
      label: '客户数量(uv)',
      minWidth: '80',
      sortable: true
    },
    {
      prop: 'duration',
      label: '访问时长(min)',
      minWidth: '120',
      slotName: 'duration',
      sortable: true
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
